import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { usePaymentContext } from "../../contexts/PaymentContext/PaymentContext";
import { PATH } from "../../router/path";
import OrderContainer from "./OrderContainer";

const OrderConfirmation: React.FC = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const {
		state: { paymentReference: contextPaymentReference },
	} = usePaymentContext((state) => state);

	const urlPaymentReference = searchParams.get("merchantReference");
	const paymentReference = contextPaymentReference || urlPaymentReference;

	if (!paymentReference) {
		navigate(PATH.CART, { replace: true });

		return null;
	}

	return <OrderContainer />;
};

export default OrderConfirmation;
